/* @flow */

import React, { useContext } from "react";
import { useTranslate } from "@awardit/react-use-translate";
import { SuccessView as SuccessViewExt } from "@crossroads/shop-views";
import { AnalyticsContext } from "@crossroads/analytics";
import { useClient } from "entrypoint/shared";
import { OrderData } from "data";
import useFormat from "helpers/use-format";
import { useData } from "crustate/react";
import { load as loadOrder } from "state/order";
import CheckIcon from "icons/checkmark-success.svg";

const Success = (): React$Node => {
  const t = useTranslate();
  const orderData = useData(OrderData);
  const { formatPrice } = useFormat();
  const gaContext = useContext(AnalyticsContext);

  return (
    <SuccessViewExt
      hasRegretPurchaseButton
      orderData={orderData}
      useClient={useClient}
      analytics={gaContext}
      formatPrice={formatPrice}
      additionalField="NONE"
      loadOrder={loadOrder}
      CheckIcon={<CheckIcon aria-label={t("ICONS.CHECK")} style={{ color: "#fff" }} />}
    />
  );
};

export default Success;
